import { render, staticRenderFns } from "./ModalTeamRoleRemove.vue?vue&type=template&id=dc3b90f4&"
import script from "./ModalTeamRoleRemove.vue?vue&type=script&lang=js&"
export * from "./ModalTeamRoleRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports